import { type Stage, stages } from 'core/types';
import type { Topic } from 'modules/comments/types';
import type { EmbeddedUser } from 'modules/core/types';
import { createOptions } from 'options';
import type { EditorValue } from 'components/RichText/types';
import { ContentObject } from 'modules/core/context';

export const statuses = stages;
export const taskStatusOptions = createOptions(statuses);

export const taskWorkBuckets = ['TODAY', 'OVERDUE', 'NEXT', 'UNSCHEDULED'] as const;
export type TaskWorkBucket = (typeof taskWorkBuckets)[number];

export type TaskStatus = Stage;

export type TaskList = {
  object_key: string;
  count: number;
  closed: number;
  opened: number;
  last_activity_at: string | null;
};

// local to list and object
export type ListTask = {
  id: number;
  status: TaskStatus;
  created_by: EmbeddedUser;
  created_at: string;
  name: string;
  content: EditorValue;
  start_date: string | null;
  due_date: string | null;
  assignees: EmbeddedUser[];
  priority: number;
  readonly topic: Topic;
  readonly work_bucket: TaskWorkBucket | null;
};

export type GenericTask = ListTask & {
  readonly object: ContentObject;
  readonly url: string;
};

export type TaskResponse = {
  task_list: TaskList;
  task: ListTask;
};
